import ViewSettingProject from "../components/ViewSettingProject";
import useEditSettingProject from "../hooks/useEditSettingProject";

const ViewSettingProjectPage = () => {
    const props = useEditSettingProject();
    return <ViewSettingProject {...props} />
}

export default ViewSettingProjectPage;